module.exports = __webpack_public_path__ + "assets/img/faf2-sy.svg";